import EtSwiper from "../components/EtSwiper.ts";
// import {type SwiperOptions} from "swiper/types";
console.debug('init for artikel_detail');

const etSwiper = new EtSwiper();
const pvdTgItems = document.querySelectorAll('.pvd_mb__tg_item') as NodeListOf<HTMLAnchorElement>;
const thumbnailItemClassActive = 'pvd_mb__tg_item--current';

window.addEventListener('load', () => {
    document.querySelectorAll('.pvd_mb__slider.swiper').forEach((element) => {
        if (element instanceof HTMLElement) {
            etSwiper.initSwiper(element).then((swiper) => {
                if (swiper) {
                    swiper.on('slideChange', () => {
                        let slideNoSlide = swiper.activeIndex + 1;

                        pvdTgItems.forEach((tgItem: HTMLAnchorElement) => {
                            let slideNoTn = parseInt(tgItem.dataset.slideno || '1') || 1;
                            if (slideNoTn === slideNoSlide) {
                                tgItem.classList.add(thumbnailItemClassActive);
                            } else {
                                tgItem.classList.remove(thumbnailItemClassActive);
                            }
                        });
                    });

                    pvdTgItems.forEach((tgItem: HTMLAnchorElement) => {
                        tgItem.addEventListener('click', () => {
                            const slideNo = parseInt(tgItem.dataset.slideno || '1') || 1;
                            swiper.slideTo(slideNo - 1);
                        });
                    });
                }
            });
        }
    });
});
